import { usePopup } from "../../../components/popup/popup";
import { NumberInput } from "../../../components/numberInput/numberInput";
import { Input } from "../../../components/input/input";
import { Button } from "../../../components/button/button";
import { ArrowIcon, FindItemIcon } from "../../../assets/icons";
import { TextInput } from "../../../components/textInput/textInput";
import { useState } from "react";
import { ProfileInfo } from "../../../components/profileInfo/profileInfo";
import { Checkbox } from "../../../components/checkbox/checkbox";
import classNames from "classnames";

import styles from "./workerTaskEditPage.module.css";

import { Text } from "../../../components/text/text";

const getEmployeesText = (n) => {
    if (n % 10 === 1 && n % 100 !== 11) return `Выбран ${n} сотрудник`;
    if ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100)) return `Выбрано ${n} сотрудника`;
    return `Выбрано ${n} сотрудников`;
}

export const InputBlock = ({ type, title, values, value, setValue, className, min, max, error }) => {
    const [Popup, open, close] = usePopup();

    const [search, setSearch] = useState("");

    return (
        <div className={classNames(styles.input_block, className)}>
            <Text as="div" variant="caption" className={styles.input_block_title} size={14}>
                {title}
            </Text>
            {type === "number" && <NumberInput error={error} val={value} setVal={setValue} min={min} max={max} />}
            {type !== "number" && type !== "user" && <Input error={error} type={type} value={value} setValue={setValue} />}
            {
                type === "user" &&
                <>
                    {
                        value.length > 0 &&
                        <Button
                            text={<ProfileInfo name={value.length > 1 ? getEmployeesText(value.length) : value[0].name} photo={value[0].photo} />}
                            type="hint"
                            icon={<ArrowIcon />}
                            onClick={open}
                        />
                    }

                    {
                        value.length === 0 &&
                        <Button
                            text="Пользователи не выбраны"
                            type="hint"
                            icon={<ArrowIcon />}
                            onClick={open}
                        />
                    }

                    <Popup>
                        <Text as="div" variant="h1" className={styles.title} >
                            Выбрать сотрудников
                        </Text>

                        <TextInput value={search} setValue={setSearch} leftContent={<FindItemIcon />} />

                        <div className={styles.users_list}>
                            {
                                values.filter(el => el.name.toLowerCase().includes(search.toLowerCase().trim())).map(data => (
                                    <Button
                                        key={data.userId}
                                        text={<ProfileInfo name={data.name} photo={data.photo} />}
                                        type="hint"
                                        icon={
                                            <Checkbox
                                                className={styles.checkbox}
                                                checked={value.findIndex(el => el.userId === data.userId) !== -1}
                                                onChange={() => {}}
                                            />
                                        }
                                        onClick={() => {
                                            if (value.findIndex(el => el.userId === data.userId) !== -1) {
                                                setValue(prev => prev.filter(el => el.userId !== data.userId));
                                            } else {
                                                setValue(prev => [...prev, data]);
                                            }
                                        }}
                                    />
                                ))
                            }
                        </div>

                        <Button
                            text="Сохранить"
                            onClick={close}
                        />
                    </Popup>
                </>
            }
        </div>
    )
}
